/**
* 레이어 팝업
* $("a.open-laypop").modalLayer();
* @options
* mask : 뒤에 그림자여부 (true | false)
* maskClass : 뒤에 그림자 클래스
*
*
*/
function centerLoginBox() {
    var ua = navigator.userAgent.toLowerCase();
    var isAndroid = ua.indexOf("android") > -1; // Detect Android devices

    if (isAndroid) {
        //window.orientation is different for iOS and Android
        if (window.orientation == 0 || window.orientation == 180) { //Landscape Mode
            return "Portrait"
        }
        else if (window.orientation == 90 || window.orientation == -90) { //Portrait Mode
            return "Landscape"
        }
    }
    else {
        if (window.orientation == 90 || window.orientation == -90) { //Landscape Mode
            return "Landscape"
        }
        else if (window.orientation == 0 || window.orientation == 180) { //Portrait Mode
            return "Portrait"
        }
    }
}

var box = centerLoginBox();
$(window).bind('orientationchange', function() {
    box = centerLoginBox();
});
var deviceSizeInfo = function() {
    var div, device;
    div = $("<div />").css({
        position:'fixed',
        top:0,
        left:0,
        width:'100%',
        height:'100%',
        'z-index':'-1',
        'background-color':'rgba(0,0,0,0)'
    }).appendTo($("body"));


    var device = {
        width  : div.width(),
        height : div.height()
    };
    div.remove();
    return device; // {width:px, height:px};
};
var objCenter = function(target) {
    var device = deviceSizeInfo();
    var $target = $(target);
    var _top = $(window).scrollTop() + ( (device.height - $target.height())*0.5 );
    var _left = Math.max($target.width(), $target[0].offsetWidth) * -0.5;
    $target.css({
        'position': 'absolute',
        'top': _top,
        'z-index': '99999',
        'left': '50%',
        'margin-left': _left
    });
};

function checkOrientation() {
    var width = $(window).width();
    var height = $(window).height();
    if(width < height){
        return parseInt(width) - 150;
    }else{
        return parseInt(height);
    }
}

var modalLayer = function( element, options ) {
    var _this = this;
    var $this = $(element); // 클릭 버튼
    var _opts = $.fn.extend({},{mask:true, maskClass:'d_modal_overlay', scroll:true}, options); // 옵션
    var target = _opts.target || $this.attr("data-target") || $this.attr("href"); // 레이어 팝업
    var $target = $(target);
    var _top;
    var _left;
    var $closeBtn;

    var $mask = $( "." + _opts.maskClass );
    if ( !$mask.length ) { // Mask가 없을 경우 생성.
        $mask = $("<div>").addClass(_opts.maskClass).appendTo($('body')).hide();
    }
    var _setup = function() {
        if ( !$target.length ) { return false; }
        $closeBtn = $target.find("a.d_close"); //닫기 버튼

        $this.on("click.modalLayer", _popOpen);
        $target.on("click", "a.d_close", _popClose);
    };
    // 레이어 위치 설정
    var _setPosition = function() {
        var device = deviceSizeInfo();

        // 설정한 top값이 있을경우.
        // if ( typeof _opts.posTop != 'undefined' ) {
        //     _top = parseInt(_opts.posTop);
        // } else {// 설정값이 없을경우 가운데 정렬.
        //     //161104
        //     if ( box == "Landscape") {
        //         _top = $(window).scrollTop() + 70;
        //     } else {
        //         if (($(window).height() - $target.height() )*0.5 < 70) {
        //             _top = $(window).scrollTop() + 70;
        //         }else {
        //             _top = $(window).scrollTop() + ( ($(window).height() - $target.height() )*0.5 );
        //         };
                
        //         if( _top < 0 ) {
        //             _top = 70;
        //         }
        //     }
        // } //170309 삭제 lyr

        _top = $(window).scrollTop() + 126; // 170309 추가 lyr

        var _left = Math.max($target.width(), $target[0].offsetWidth) * -0.5;
        $target.css({
            'position': 'absolute',
            'top': _top,
            'z-index': '99999',
            'left': '50%',
            'margin-left': _left
        });
    };
    var _popOpen = function() {
        var ajaxload = _opts.ajaxload && _opts.ajaxload($this, $target, _this);

        // ajaxload

        _setPosition();

        if ( _opts.mask ) { $mask.fadeIn(200); }
        $target.fadeIn(350);
        $mask.css('height',$('html').height());//151005



        // 이벤트 추가
        $(window).on('orientationchange', _setPosition);
        _opts.evStart && _opts.evStart($this, $target);

        event.preventDefault();
    };

    var _popClose = function() {
        if ( _opts.mask ) { $mask.hide(); }//150727_modify
        $target.hide();//150727_modify
        _opts.evEnd && _opts.evEnd($this, $target);

        // 이벤트 삭제
        $(window).off('orientationchange', _setPosition);
        //event.preventDefault();
    };

    this.open = function() {
        _popOpen();
    };
    this.close = function() {
        _popClose();
    };
    this.center = function() {
        _setPosition();
    };
    this.setup = function() {
        _setup();
    };
    this.options = _opts;
    _setup();
};


var modalLayer2 = function(that, option) {
    var _this = this;
    var self  = $(that);
    var defaults = {
        //position    : [],       // 레이어 위치값. [ top, left ] - 추후 적용예정
        maskLayer   : '',
        //scroll      : true,     // 스크롤 가능 여부 - 추후 적용예정.
        contents    : that,     // 센터 위치 구할 객체.
        openbtn     : '',       // 열기 버튼지정. class or ID 값 지정.
        closebtn    : '',        // 닫기 버튼지정. class or ID 값 지정.
        showOpenBegin   : null, //function() {},
        showOpenAfter   : null, //function() {},
        showCloseBegin  : null, //function() {},
        showCloseAfter  : null, //function() {},
    };
    var $window = $(window);
    var options = $.extend({}, defaults, option);
    var modalbox  = options.contents == that ? $(options.contents) : $(options.contents, that);
    var maskLayer = options.maskLayer ? $(options.maskLayer) : null;
    if ( !modalbox.length ) return;

    var _init = function() {

        if ( maskLayer && !maskLayer.length ) { maskLayer = $('<div>').appendTo($('body')).addClass('d_modal_overlay'); }//161104

        // 열기버튼
        if ( options.openbtn ) { $(options.openbtn).on('click', _this.showLayerOpen); }

        // 닫기버튼
        if ( options.closebtn ) { $(options.closebtn, self).on('click', _this.showLayerClose); }
    };

    // 레이어 가운데 정렬
    this.layerCenter = function(callbackFn) {
        // 위치값 구하기 위해 일단 안보이게 해놓고 오픈.
        var _width_ = 0, _height_ = 0, _top = 0;
        _width_  = modalbox.width();
        _height_ = modalbox.height();

        /*161104*/
        // if ( box == "Landscape") {
        //     _top = $(window).scrollTop() + 70;
        // } else {
        //     if (($(window).height() - modalbox.height() )*0.5 < 70) {
        //         _top = $(window).scrollTop() + 70;
        //     }else {
        //         _top = $(window).scrollTop() + ( ($(window).height() - modalbox.height() )*0.5 );
        //     };
            
        //     if( _top < 0 ) {
        //         _top = 70;
        //     }
        // } //170309 삭제 lyr
        _top = $(window).scrollTop() + 126; // 170309 추가 lyr

        if (!modalbox.hasClass('full-popup')) {
            modalbox.css({
                'position': 'absolute',
                //'top' : $window.scrollTop() + $window.height()/2 - _height_/2,
                'top' : _top,
                'left': $window.width()/2 - _width_/2,
                'margin-top' : 0,
                'margin-left': 0
            });
        } else if (modalbox.hasClass('full-popup')){
            $('html, body').scrollTop(0);
        }
        /* //161104 */
        
        /* 150115_del
        if ( options.maskLayer && maskLayer.length ) {
            maskLayer.css({
                'position': 'absolute',
                'top' : 0,
                'height' : ($(document).height() > $(window).height()) ? $(document).height() : $(window).height() // 150114_update
            });
        }
        */

        // CALLBACK 함수 호출
        if ( callbackFn && callbackFn instanceof Function ) callbackFn();
    };
    // 레이어 열기.
    this.showLayerOpen  = function() {
        if ( options.showOpenBegin && options.showOpenBegin instanceof Function ) options.showOpenBegin(self);
        self.css('opacity',0).show(100,
            function() {
                _this.layerCenter(function() {
                    //160323
                    self.hide().css('opacity','').fadeIn('fast',function() {
                        maskLayer.css('height',$('html').height());
                    });
                    if ( options.maskLayer && maskLayer.length ) { maskLayer.fadeIn('fast'); }
                    if ( options.showOpenAfter && options.showOpenAfter instanceof Function ) options.showOpenAfter(self);
                });
            });
        $window.on('orientationchange', _this.layerCenter);

        return false;
    };

    // 레이어 닫기.
    this.showLayerClose = function() {
        if ( options.showCloseBegin && options.showCloseBegin instanceof Function ) options.showCloseBegin(self);
        $window.off('orientationchange', _this.layerCenter);
        if ( options.maskLayer && maskLayer.length ) { maskLayer.fadeOut('fast'); }
        self.fadeOut('fast', function() {
            if ( options.showCloseAfter && options.showCloseAfter instanceof Function ) showCloseAfter(self);
        });

        return false;
    };

    _init();
};

$.fn.extend({
    modalLayer : function(options) {
        return this.each(function() {
            if ( !$(this).data("modalLayer") ) {
                $(this).data("modalLayer", new modalLayer(this, options));
            }
        })
    },
    modalLayer2 : function(option) {
        return this.each(function() {
            if ( !$(this).data('modalLayer2') ) {
                $(this).data('modalLayer2', new modalLayer2(this, option));
            }
        });
    }
});

$(function() {
    $('.open-laypop').modalLayer();
});



//상단 타임라인 메뉴
window.weekAwardMenuSwiper;

/*
* 주간 인기상 전체보기 버튼 클릭시.
*/
function viewVoteList(target) {
    'use strict';
    var self = ( $(event.target)[0].tagName.toLocaleLowerCase() == 'span' ) ? $(event.target).parent() : $(event.target);
    $(target).slideToggle(200, function() {
        if ($(this).is(':visible')) {
            self.addClass('active').find('>span').html('접기');
            graphTxtSizeCheck(target);
        } else {
            self.removeClass('active').find('>span').html('전체보기');
        }
    });
    event.preventDefault();
}


/*
* 20순위 리스트 - 음원, 투표 텍스트 위치 조절.
* 음원부분의 사이즈가 낮을경우 글자 겹침 해결을 위해 스크립트로 조절.
*/

function graphTxtSizeCheck(t) {
    'use strict';
    var target = t || '.vote-list';
    var graphs  = $('.vote-chart .graph', target);
    if ( !graphs.length ) return false;
    var minSize = 40; //최소 사이즈
    graphs.each(function() {
        var w = parseInt($(this).find('>.bar1').css('width'));
        if ( w < minSize ) {
            $(this).find('>.bar2>span').css('left', minSize-w);
        }
    });
}
/*
* 주간인기상 타임라인.
*/
$(function() {
    'use strict';

    // 주간 서브 메뉴 좌우 swipe 호출.
    // @required pulgin. - jquery.js, idangerous.swiper.js
    window.weekAwardMenuSwiper = $('.menu-timebar > .swiper-container').swiper({
        slidesPerView: 'auto'
    });

    // 순위 리스트 - 음원, 투표 텍스트 위치 조절.
    graphTxtSizeCheck();

   // 전체보기 150129_add
    //$('.content').on('click','.d_list_view button',function() {
    //    var btn = $(this),
    //        listCont = $(this).parents('.d_list_view').prev('ul.vote-list');
    //    listCont.slideToggle(10, function() {
    //        if ($(this).is(':visible')) {
    //            btn.addClass('active').find('>span').html('접기');
    //            graphTxtSizeCheck(listCont);
    //        } else {
    //            btn.removeClass('active').find('>span').html('전체보기');
    //
    //        }
    //    });
    //    $('html, body').animate({scrollTop: $(window).scrollTop() - listCont.height()}, 10);
    //});

    // dimmed 클릭시 레이어 닫힘 161104
    $(function() {
        'use strict';
        // dimmed 클릭시 레이어 닫힘 150115_add
        $('.d_modal_overlay').on('click touchstart',function(e) {
            e.stopPropagation();
            var $target = $(e.target),
                $pop = $target.closest('.melon-awards-popup');
            if ($pop.length === 0) {
                $('.melon-awards-popup .d_close').trigger('click');
            }
        });
    });
});
